import dom, { Fragment } from "../../../dist/jsx-render/dom"
import { ITableColumn } from "./ITableColumn";
import { MsoTable } from "./MsoTable";
import { Avatar, AvatarProps } from "../../Components/UIElements/Avatar";
import { ColumnString } from "./ColumnString";

export class ColumnUser extends ColumnString {
    protected useAvatar: boolean;

    public constructor(table: MsoTable, def: ITableColumn, protected rootId: string) {
        super(table, def, rootId);

        this.useAvatar = def.useAvatar;

        if (this.isEditable) {
            this.recreateCellOnUpdate = true;
        }
    }

    getCellClass(): string {
        if (this.isEditable) {
            return super.getCellClass() + " mt-textedit";
        }
        else {
            return super.getCellClass();
        }
    }

    public createCell(rowModel: any, idField: string): HTMLElement {
        let cell = super.createCell(rowModel, idField);

        if (this.isEditable) {
            cell.classList.add("dropdown");
            cell.classList.add("align-items-stretch");

            this.table.inlineEdit.createDropdown(cell, rowModel, idField, this.field);
        }

        return cell;
    }

    public getContent(row: any): HTMLElement {
        let avatarProps: AvatarProps = {
            name: row[this.def.dataField]
        };

        if (row[this.def.dataField + "_Id"]) {
            avatarProps.id = row[this.def.dataField + "_Id"];
        }

        if (row[this.def.dataField + "_Type"]) {
            avatarProps.type = row[this.def.dataField + "_Type"];
        }

        if (row[this.def.dataField + "_HasImage"]) {
            avatarProps.hasImage = true;
        }

        let avatar = new Avatar(avatarProps);

        let result = <span>
            {this.useAvatar && row[this.def.dataField]
                ? avatar.render()
                : []}
            {row[this.def.dataField]}
        </span>;

        return result;
    }

    public isFilterVisible(model: any): boolean {
        if (this.filteredItems) {
            let value = model[this.field];
            if (value && value.trim() == "")
                value = null;

           return value in this.filteredItems;
        }
        return true;
    }
}